module.exports = __webpack_public_path__ + "static/media/XDeleteIcon.f2477b2d.svg";